import { createContext } from 'react';
import type { PriceProps } from 'Components/frameworks/price/Price';
import 'Components/frameworks/price/Price';
export type FavoriteProductType = {
  id?: string;
  reference?: string;
  adultsNumber: number;
  arrivalDate: number;
  childrenCount?: number;
  departureCity: string;
  departureDate: number;
  duration: number;
  id?: string;
  isBookable?: boolean;
  kids: Array<any>;
  kidsValidationState: Array<ValidationState>;
  origin: 'BOOKMARK' | 'SEARCH';
  priceOfStay: PriceProps;
  product: Product;
  reference?: string;
  type?: string;
  upsells?: StayUpsellsEntity;
};
export type favoriteProductListContextType = {
  favoriteProductsState: {
    favoriteProductList: Array<FavoriteProductType>;
    hasTooManyFavorites: boolean;
    showcaseLatestFavorite: boolean;
    showAllFavorite: boolean;
  };
  loading: boolean;
  addTravelPlan: (savedProposal: Proposal, product: Product) => void;
  setFavoriteProductList: (
    list: Array<FavoriteProductType>,
    showcaseLatestFavorite: boolean,
    showAllFavorite: boolean,
  ) => void;
  setHasTooManyFavorites: (hasTooManyFavorites: boolean) => void;
};
export const FavoriteProductListContext = createContext<favoriteProductListContextType>({
  favoriteProductsState: {
    favoriteProductList: [],
    hasTooManyFavorites: false,
    showcaseLatestFavorite: false,
    showAllFavorite: false,
  },
  loading: false,
  addTravelPlan: () => {},
  setHasTooManyFavorites: () => {},
  setFavoriteProductList: () => {},
});
